import Player from "@src/views/BackOffice/player";
const Footer = () => {
  return (
    <div className="TuneIn">
      <Player />
    </div>
  );
};

export default Footer;
